import { CircularProgress, CircularProgressProps } from '@mui/material';
import React from 'react';

export interface SpinnerProps extends Pick<CircularProgressProps, 'size'> {}

export const Spinner = ({ size = 24 }: SpinnerProps) => {
    return <CircularProgress color="secondary" size={size} />;
};
